let Widget3dsoft = require('./Main.js');

/**
 * Affiche la page Date
 * @returns {undefined}
 */
Widget3dsoft.prototype.showFormDate = function () {

    if (this.verifStepClientDone()) {
        var self = this;
        $(self.sClass + ' .widget3Dsoft-loading').show();

        fCallbackFormDate = function (response) {
                    $(self.sClass).html(response);
                    self.showInterventions(self);
                    self.showAteliers(self,function(){
                        var iMoisReceptionShowDate = '';
                        var iAnneeReceptionShowDate = '';

                        //Date reception deja  renseignee donc on va la selectionner
                        if (self.rendezvous.sDateReception) {
                            iAnneeReceptionShowDate = self.rendezvous.sDateReception.split("-")[0]; // annee
                            iMoisReceptionShowDate = parseInt(self.rendezvous.sDateReception.split("-")[1], 10); // mois
                            iDayReceptionShowDate = parseInt(self.rendezvous.sDateReception.split("-")[2], 10); // day
                            $(self.sClass + ' .widget3Dsoft-dateRecSelected').html(self.rendezvous.sDateReception);
                            if (self.rendezvous.iHeureReception) {
                                aHeure = self.convertMinToHour(self.rendezvous.iHeureReception);
                                $(self.sClass + ' .widget3Dsoft-heureRecSelected').html(aHeure.sHeures + 'h' + aHeure.sMins);
                            }
                        }

                        self.showCalendarReception(self, iMoisReceptionShowDate, iAnneeReceptionShowDate,function(){
                            //Si on a dejaÂ  selectionnee une date et une heure on va afficher la reception et l'heure choisie
                            if (self.rendezvous.sDateReception) {
                                self.selectDayReception(self, iDayReceptionShowDate, iMoisReceptionShowDate, iAnneeReceptionShowDate);
                            }
                            
                            $(self.sClass + ' .widget3Dsoft-div-choosedate').remove();
                        });
                        
                        if (self.rendezvous.sDateRestitution) {
                            var iAnneeRestitutionShowDate = self.rendezvous.sDateRestitution.split("-")[0]; // annee
                            var iMoisRestitutionShowDate = parseInt(self.rendezvous.sDateRestitution.split("-")[1], 10); // mois
                            var iDayRestitutionShowDate = parseInt(self.rendezvous.sDateRestitution.split("-")[2], 10); // day
                            $(self.sClass + ' .widget3Dsoft-dateRestSelected').html(self.formatDate(self.rendezvous.sDateRestitution));
                            if (self.rendezvous.iHeureRestitution) {
                                var aHeure = self.convertMinToHour(self.rendezvous.iHeureRestitution);
                                $(self.sClass + ' .widget3Dsoft-heureRestSelected').html(aHeure.sHeures + 'h' + aHeure.sMins);
                            }
                            self.showCalendarRestitution(self, iMoisRestitutionShowDate, iAnneeRestitutionShowDate,function(){
                                self.selectDayRestitution(self, iDayRestitutionShowDate, iMoisRestitutionShowDate, iAnneeRestitutionShowDate);
                                self.showVehiculesCourtoisie(self);
                            });
                        }
                        
                        if(self.rendezvous.bLeClientAttend == true){
                            self.checkClientAttendLibelle(self);
                        }
                        
                        
                        //if(self.rendezvous.bVehCourtoisie == true){
                        //    self.checkVehCourtoisieLibelle(self);
                        //}
                        
                        if(self.oSite.bShowShuttle){
                            $(self.sClass + ' .widget3Dsoft-bShuttleCheckbox').click(function(){
                                self.checkBShuttle(self);
                            });
                            $(self.sClass + ' .widget3Dsoft-bShuttle').click(function(){
                                self.checkBShuttleLibelle(self);
                            });
                        }
                    });

                    self.filArianne(self,'stepDate');
                    
                    self.completeFooter();
                    self.adaptDimensions(self);
                    self.headerProfil(self);

                    
                    
                    //Events
                    $(self.sClass + ' .widget3Dsoft-receptionnaire').change(function(){
                        console.log('change select receptionnaire');    
                        self.changeReceptionnaire(self);
                    });
                    
                    $(self.sClass + ' .select_hour_reception').click(function(){
                            self.clickDisplayHour();
                    });
                    
                    $(self.sClass + ' .select_hour_restitution').click(function(){
                            self.clickDisplayHourRestitution();
                    });
                    
                    $(self.sClass + ' .widget3Dsoft-vehCourtoisie').change(function(){
                            self.selectVehCourtoisie(self);
                    });
                    
                    $(self.sClass + ' .widget3Dsoft-btnValiderDates').click(function(){
                            self.btnValiderDates(self);
                    });
                    
                    $(self.sClass + ' .togglepannelContentDateRec').click(function(){
                            $(self.sClass + ' .widget3Dsoft-pannelContentDateRec').toggle();
                    });
                    
                    $(self.sClass + ' .togglepannelContentDateRest').click(function(){
                            $(self.sClass + ' .widget3Dsoft-pannelContentDateRest').toggle();
                    });
                    
                    $(self.sClass + ' .widget3Dsoft-divclientAttend ').click(function(){
                        self.checkClientAttend(self);
                    });
                    
                    $(self.sClass + ' .widget3Dsoft-divclientAttendLibelle ').click(function(){
                        self.checkClientAttendLibelle(self);
                    });
                    $(self.sClass + ' .widget3Dsoft-vehCourtoisieLibelle ').click(function(){
                        self.checkVehCourtoisieLibelle(self);
                    });
                    
                    
                    
                    $(self.sClass + ' .widget3Dsoft-loading').hide();
                    
                };
        
        
        if(self.sHtmlFormDate != undefined){
            fCallbackFormDate(self.sHtmlFormDate);
        }else{
            //Get html of form date
            self.ajax('GET',
                    this.sServerURL + 'widget/form-date' + this.sParamsGet,
                    {},
                    function (response, statut) {
                        self.sHtmlFormDate = response;
                        fCallbackFormDate(response);
                    });
        }
    }
};

//INTERVENTIONS

/**
 * Affiche la duree des interventions
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.showInterventions = function (self) {
    self.rendezvous.iDureeTotale = 0;
    if(self.rendezvous.aInterventions.length > 0){
        for (iKey in self.rendezvous.aInterventions) {
            var iIdIntervention = self.rendezvous.aInterventions[iKey];
            self.rendezvous.iDureeTotale += self.oListeInterventions.getIntervention(iIdIntervention).duree;
        }
    }
    var aDuree = self.convertMinToHour(self.getDureeTotale(self));

    $(self.sClass + ' .widget3Dsoft-dureeInterventions').html(aDuree.sHeures + 'h' + aDuree.sMins);
}

//ATELIERS

/**
 * Affiche la liste des ateliers
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.showAteliers = function (self, callback) {
    self.aAteliers = self.retrieveAteliers(self,function(){
        $(self.sClass + ' .widget3Dsoft-atelier').append('<option value="0">' + self.sLanguage.DATES_MSG_TOUS_ATELIER + '</option>');
        for (iIdAtelier in self.aAteliers) {
            var sSelected = iIdAtelier == self.rendezvous.iIdAtelier ? 'selected' : '';
            $(self.sClass + ' .widget3Dsoft-atelier').append('<option value="' + iIdAtelier + '" ' + sSelected + '>' + self.aAteliers[iIdAtelier].sDesignation + '</option>');
        }
        $(self.sClass + ' .widget3Dsoft-atelier').change(function(){
            self.changeAtelier(self);
        });
        if (typeof (callback) == 'function') {
            callback();
        }
    });
};

/**
 * Appelle le serveur pour trouver les ateliers
 * @returns {Array|response.aAteliers}
 */
Widget3dsoft.prototype.retrieveAteliers = function (self,callback) {

    var aAteliers = [];
    self.ajax('GET',
            this.sServerURL + 'rest/ateliers' + this.sParamsGet,
            {},
            function (response, statut) {

                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }
                
                if (response.success == true) {
                    self.aAteliers = [];
                    for (key in response.aAteliers) {
                        self.aAteliers[response.aAteliers[key].id] = response.aAteliers[key];
                    }
                }
                if (typeof (callback) == 'function') {
                        callback();
                }
            },true
    );

    return self.aAteliers;
};

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.changeAtelier = function (self) {
    //On change d'atelier donc on reinitialise les dates et receptionnaires
    //self.rendezvous.sDateReception = '';
    self.rendezvous.sDateRestitution = '';
    self.rendezvous.iIdReceptionnaire = '';
    self.rendezvous.iIdAtelier = $(self.sClass + ' .widget3Dsoft-atelier').val() === '' ? null : $(self.sClass + ' .widget3Dsoft-atelier').val();
    self.rendezvous.sAtelierDesignation = '';
    if(self.aAteliers[self.rendezvous.iIdAtelier] != undefined){
        self.rendezvous.sAtelierDesignation = self.aAteliers[self.rendezvous.iIdAtelier].sDesignation;
    } 
    
    //On reaffiche les calendrier
    var sAnnee = self.sAnnee === null ? '' : self.sAnnee;
    var sMois = self.sMois === null ? '' : self.sMois;
    self.showCalendarReception(self, sMois, sAnnee,function(){
        
        if(self.rendezvous.sDateReception != '' && self.rendezvous.sDateReception != null){
            var sYear = self.rendezvous.sDateReception.substr(0,4);
            var sMonth = parseInt(self.rendezvous.sDateReception.substr(5,2));
            var sDay = self.rendezvous.sDateReception.substr(8,2);
            self.selectDayReception(self, sDay, sMonth, sYear);
        }
    });
};

//RECEPTION

/**
 * En fonction de l'idAtelier si on a pas encore ce calendrier en cache, on va le chercher
 * Ensuite appelle displayCalendar pour afficher le calendrier
 * @param widget3Dsoft self
 * @param {type} iMois
 * @param {type} iAnnee
 * @returns {undefined}
 */
Widget3dsoft.prototype.showCalendarReception = function (self, iMois, iAnnee,callback) {  
    self.toggleTabSearchCalendar(self,'calendar');
    //Le calendrier est different selon l'atelier
    var iIdAtelier = $(self.sClass + ' .idget3Dsoft-atelier').val() === '' ? null : $(self.sClass + ' .widget3Dsoft-atelier').val();

    if (iAnnee === "" || iMois === "") {
        var oDate = new Date;
        iAnnee = oDate.getFullYear();
        iMois = parseInt(oDate.getMonth()) + 1;
    }

    //On met en cache l'anne et le mois choisi

    self.sAnnee = iAnnee;
    self.sMois = iMois;
    var sMois = iMois < 10 ? '0' + iMois : iMois;
    
    //If we havn't infos of this month, we search it
    if (self.jCalendrier[iIdAtelier] === undefined
            || self.jCalendrier.length == 0
            || jQuery.isEmptyObject(self.jCalendrier[iIdAtelier])
            || self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)] === undefined
            || jQuery.isEmptyObject(self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)])) {            
        self.searchCalendar(iAnnee, iMois, self,function(){
            //Calback asynchrone, sera execute une fois que les donnes seront recuperee         
            var oCalendar = self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)];
            self.displayCalendar(self, self.sClass + ' .widget3Dsoft-calendarReception', iMois, iAnnee, 'showCalendarReception', 'selectDayReception', oCalendar, 'widget3Dsoft-calReception', self.rendezvous.sDateReception,callback);
        });

    }else{
        var oCalendar = self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)];
        self.displayCalendar(self, self.sClass + ' .widget3Dsoft-calendarReception', iMois, iAnnee, 'showCalendarReception', 'selectDayReception', oCalendar, 'widget3Dsoft-calReception', self.rendezvous.sDateReception,callback);
    }
};

/**
 * Quand on clique sur un jour du calendrier reception
 * @param widget3Dsoft self
 * @param {type} iDay
 * @param {type} iMois
 * @param {type} iAnnee
 * @returns {undefined}
 */
Widget3dsoft.prototype.selectDayReception = function (self, iDay, iMois, iAnnee) {
    $(self.sClass + ' .widget3Dsoft-loading').show();

    self.completeJourInfo(self, self.sClass + ' .widget3Dsoft-reception', iDay, iMois, iAnnee);


    //Seulement si ce jour est selectionnable
    iMois = parseInt(iMois);
    iDay = parseInt(iDay);
    var sMois = iMois < 10 ? '0' + iMois : iMois;
    var sDay = iDay < 10 ? '0' + iDay : iDay;

    if ($(self.sClass + ' .widget3Dsoft-calReception_' + String(sDay) + '_' + String(sMois) + '_' + String(iAnnee)).hasClass('pointer')) {
        self.sDay = iDay;

        //Design the day selected
        $(self.sClass + ' .widget3Dsoft-calendarReception .day').removeClass('daySelected');
        $(self.sClass + ' .widget3Dsoft-calReception_' + sDay + '_' + sMois + '_' + iAnnee).addClass('daySelected');

        //On mets aÂ  jour la date de reception de l'objet rendezvous
        self.rendezvous.sDateReception = iAnnee + '-' + sMois + '-' + sDay;
        $(self.sClass + ' .widget3Dsoft-dateRecSelected').html(self.formatDate(self.rendezvous.sDateReception));

        //On met aÂ  jour la date de restitution de l'objet rendez vous
        $(self.sClass + ' .widget3Dsoft-dateRestSelected').html(self.formatDate(self.rendezvous.sDateReception));
        self.rendezvous.sDateRestitution = self.rendezvous.sDateReception;

        //On met a jour l'horaire de restitution
        $(self.sClass + ' .widget3Dsoft-dateRestSelected').html(self.rendezvous.sDateReception);
        var iIdAtelier = $(self.sClass + ' .widget3Dsoft-atelier').val();
        self.rendezvous.iHeureRestitution = parseInt(self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)][self.rendezvous.sDateReception]['heure_fermeture']);
        var aHourRest = self.convertMinToHour(self.rendezvous.iHeureRestitution);
        $(self.sClass + ' .widget3Dsoft-heureRestSelected').html(aHourRest.sHeures + 'h' + aHourRest.sMins + ' <img src="' + self.sServerURL + 'img/edit-icon.png">');
      
        //On va chercher les receptionnaires et leurs horaires
        self.retrieveReceptionnairesAndHours(self, iDay, iMois, iAnnee,function(){
            //aReceptions contient les receptionnaires de la date de reception
            self.aReception = [];
            $.each(self.jReception, function (key, oReceptionnaire) {
                self.aReception[key] = oReceptionnaire._REC_DESIGNATION;
            });


            //Receptionnaires
            self.displayReceptionnaires(self);

            //Hours
             self.displayHours(self, self.sClass + ' .widget3Dsoft-reception-plageHoraire', self.rendezvous.sDateReception, 'chooseHourReception', self.rendezvous.iHeureReception);
            $(self.sClass + ' .widget3Dsoft-div-hours').show();// fin row
            $(self.sClass + ' .arrow_hour').attr('src', self.sServerURL + 'img/rec_arrow_down.png');

            //On prepare la restitution
            //self.showCalendarRestitution(self.sClass + ' .widget3Dsoft-calendarRestitution',iAnnee, iMois,self);

            //on va chercher les vehicules de courtoisie
            //self.showVehiculesCourtoisie(self);

            //On positionne la page sur la partie receptionnaires
            if ($(self.sClass + ' article').scrollTop() == 0) {
                $(self.sClass + ' article').animate({
                    scrollTop: $(self.sClass + ' .widget3Dsoft-pannelReception').offset().top},
                'fast');
            }
            $(self.sClass + ' .widget3Dsoft-div-choosedate').hide();
            self.clickDisplayHour();
            //$(self.sClass + ' article').scrollTop($(self.sClass + ' .widget3Dsoft-pannelReception').offset().top);  
        });

       
    }

    $(self.sClass + ' .widget3Dsoft-loading').hide();
};

/**
 * 
 * @param widget3Dsoft self
 * @returns {undefined} 
 */
Widget3dsoft.prototype.displayReceptionnaires = function (self) {
    //Select receptionnaire
    $(self.sClass + ' .widget3Dsoft-receptionnaire').empty();
    $(self.sClass + ' .widget3Dsoft-receptionnaire').append($('<option>', {
        value: '',
        text: self.sLanguage.DATES_RECEPTIONNAIRE_DISPONNIBLE
    }));

    $.each(self.jReceptionsHours[self.rendezvous.sDateReception], function (key, oReceptionnaire) {
     
        if ( parseInt(key) !== parseInt(0) )
        {  
            $(self.sClass + ' .widget3Dsoft-receptionnaire').append($('<option>', {
                value: key,
                text: self.jReception[key]._REC_DESIGNATION
            }));
        }
    });

    //On affiche
    $(self.sClass + ' .widget3Dsoft-div-receptionnaire').show();
    
 



    //Receptionnaire par defaut
 
    if(self.rendezvous.iIdReceptionnaire != undefined && self.rendezvous.iIdReceptionnaire != null &&  self.rendezvous.iIdReceptionnaire != ""){
         $(self.sClass + ' .widget3Dsoft-receptionnaire').val(self.rendezvous.iIdReceptionnaire);
    }else if (self.aAteliers[$(self.sClass + ' .widget3Dsoft-atelier').val()] !== undefined) {
        var iIdRecDefault = self.aAteliers[$(self.sClass + ' .widget3Dsoft-atelier').val()].iRecId;
        $(self.sClass + ' .widget3Dsoft-receptionnaire').val(iIdRecDefault);
    }

};

//HOURS

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.displayHours = function (self, sSelecteur, sDate, sClickHour, iHourSelected) {

    //Sans la date on ne fait pas de traitement des heures
    if(sDate !== undefined && sDate !== '' && sDate !== null){
        var iIdAtelier = $(self.sClass + ' .widget3Dsoft-atelier').val();
        var sAnnee = sDate.split("-")[0]; // annee
        var sMois = sDate.split("-")[1]; // mois
        var sDay = sDate.split("-")[2]; // jour
        var numberofDay = new Date(sDate);
        var numberOfTheday = numberofDay.getDay() - 1;
        // var hOuverture = parseInt(self.jCalendrier[iIdAtelier][String(sAnnee) + String(sMois)][sDate]['heure_ouverture']);
        // var hDebutCoupure = parseInt(self.jCalendrier[iIdAtelier][String(sAnnee) + String(sMois)][sDate]['heure_debut_coupure']);
        // var hFinCoupure = parseInt(self.jCalendrier[iIdAtelier][String(sAnnee) + String(sMois)][sDate]['heure_fin_coupure']);
        // var hFermeture = parseInt(self.jCalendrier[iIdAtelier][String(sAnnee) + String(sMois)][sDate]['heure_fermeture']);
      
        var hOuverture = parseInt(self.oSite.horaire_semaine[numberOfTheday]['sHeureOuverture']) ;
        var hDebutCoupure =parseInt(self.oSite.horaire_semaine[numberOfTheday]['sHeureDebutCoupure']) ;
        var hFinCoupure = parseInt(self.oSite.horaire_semaine[numberOfTheday]['sHeureFinCoupure']);
        var hFermeture = parseInt(self.oSite.horaire_semaine[numberOfTheday]['sHeureFermeture']);
      

        //Pour le site on prend l'heure de debut pour la date de fin de disponnibilites de dispos
        //hFermeture = parseInt(self.jCalendrier[iIdAtelier][String(sAnnee) + String(sMois)][sDate]['heure_depot']);
        var bCoupure = false;//savoir si on a depasse la coupure
        var iCptIteration = 1;//tous les 4 on ferme la ligne

        $(sSelecteur).empty();

        var htmlHour = '<div class="row padding-top-5 padding-bottom-5 text-center">';//First row
      
        self.rendezvous.iIdReceptionnaire = $(self.sClass + ' .widget3Dsoft-receptionnaire').val();
     
        if(self.rendezvous.iIdReceptionnaire !== undefined){
            
            for (h = hOuverture; h < hFermeture; h += 15) {

                var heure = parseInt(h / 60);
                var minutes = h % 60;
                var sHeure = (heure < 10) ? '0' + heure : heure;
                var sMinutes = (minutes < 10) ? '0' + minutes : minutes;


                var sClassDisponnibilite = self.getDisponnibiliteHoraire(self, sDate, h, self.rendezvous.iIdReceptionnaire);//Couleur de la dispo
                                
                var sSelected = (h == iHourSelected) ? 'heure_selected' : '';
                htmlHour += '<span class="heure_bloc padding-bottom-5"><span id="'+sClickHour+'_'+h+'" onclick="' + self.sVarName + '.' + sClickHour + '(' + self.sVarName + ',' + h + ');" class="' + sClassDisponnibilite + ' ' + sSelected + '">' + sHeure + 'h' + sMinutes + '</span></span>';

                //Coupure
                if (!bCoupure && (h + 15) >= hDebutCoupure) {
                    h = hFinCoupure - 15;
                    bCoupure = true;
                }

                //On ferme proprement la row tous les 4 blocs
                if (iCptIteration % 4 == 0) {
                    htmlHour += '</div>';
                    //On creer une nouvelle ligne sauf si cette iteration est la derniere
                    if ((h + 15) < hFermeture) {
                        htmlHour += '<div class="row padding-top-5 padding-bottom-5  text-center">';
                    }
                }

                iCptIteration++;
            }
        }
        //si on a pas fini la boucle sur un multiple de 4, on ferme la row
        if ((iCptIteration - 1) % 4 != 0) {
            htmlHour += '</div>';
        }

        $(sSelecteur).append(htmlHour);// fin row
    }
};

/**
 * indique la disponnibilite de creneau
 * Si l'idReceptionnaire est null ou vide on parcours les receptionnaires
 * si l'un d'entre eux est dispo alors le creneau est ok
 * @param string sDate
 * @param int iCreneau
 * @param int iIdReceptionnaire
 */
Widget3dsoft.prototype.getDisponnibiliteHoraire = function (self, sDate, iCreneau, iIdReceptionnaire) {
    var sClass = '';

    if(iIdReceptionnaire !== undefined){

        if (iIdReceptionnaire === null || iIdReceptionnaire === '') { //c'est pour les receptionnaire disponible on fait le global
            iIdReceptionnaire = 0;
        }
        
        if (self.jReceptionsHours != undefined && self.jReceptionsHours[sDate] != undefined && self.jReceptionsHours[sDate][iIdReceptionnaire] != undefined) {
            var iNbReceptionMaxParCreneau = self.jReceptionsHours[sDate][iIdReceptionnaire][-1];
            var iNbReceptionCreneau = self.jReceptionsHours[sDate][iIdReceptionnaire][iCreneau];

            if (iNbReceptionCreneau === undefined) {
                iNbReceptionCreneau = 0;
            }

            if (iNbReceptionCreneau < iNbReceptionMaxParCreneau) {
                sClass = 'heure_disponnible';
            } else {
                sClass = 'heure_indisponnible';
            }

        } else {
            sClass = 'heure_indisponnible';
            $.each(self.jReceptionsHours[sDate], function (key, aCreneaux) {
                var iNbReceptionMaxParCreneau = aCreneaux[-1];//-1 is the id of max rdvs
                var iNbReceptionCreneau = aCreneaux[iCreneau];

                if (iNbReceptionCreneau === undefined) {
                    iNbReceptionCreneau = 0;
                }
                //for orange : if (iNbReceptionMaxParCreneau - iNbReceptionCreneau == 1) {
                if (iNbReceptionCreneau <= iNbReceptionMaxParCreneau) {
                    sClass = 'heure_disponnible';
                }
            });
        }


    }
    return sClass;
}

/**
 * 
 * @param string h
 * @param widget3Dsoft self
 */
Widget3dsoft.prototype.chooseHourReception = function (self, h) {
    
    if( !$('#chooseHourReception_'+h).hasClass('heure_indisponnible') ){
        
        self.rendezvous.iHeureReception = h;
        self.rendezvous.iHeureRestitution = 1080;//@todo mettre la date de fin de journee
        var aHour = self.convertMinToHour(h);

        //Afficher l'heure dans les en-tete
        $(self.sClass + ' .widget3Dsoft-heureRecSelected').html(aHour.sHeures + 'h' + aHour.sMins + ' <img src="' + self.sServerURL + 'img/edit-icon.png">');

        //Fermer les div
        self.clickDisplayHour();
        $(self.sClass + ' .widget3Dsoft-pannelContentDateRec').toggle();

        //Preparer le calendrier des restitutions
        self.showCalendarRestitution(self, self.sMois, self.sAnnee);

        //Afficher la selection du vehicule de courtoisie
        self.showVehiculesCourtoisie(self);
    }

};

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.clickDisplayHour = function () {
    var self = this;
    if ($(self.sClass + ' .arrow_hour').attr('src') == this.sServerURL + 'img/rec_arrow_up.png') {
        $(self.sClass + ' .arrow_hour').attr('src', this.sServerURL + 'img/rec_arrow_down.png');
        $(self.sClass + ' .container_plage_horaire').hide();
    } else {
        $(self.sClass + ' .arrow_hour').attr('src', this.sServerURL + 'img/rec_arrow_up.png');
        $(self.sClass + ' .container_plage_horaire').show();
    }
    
};

//RESTITUTION

/**
 * 
 * @param widget3Dsoft self
 * @param {type} iMois
 * @param {type} iAnnee
 * @returns {undefined}
 */
Widget3dsoft.prototype.showCalendarRestitution = function (self, iMois, iAnnee,callback) {
    
    if (this.verifStepClientDone()) {
        //Le calendrier est different selon l'atelier
        var iIdAtelier = $(self.sClass + ' .widget3Dsoft-atelier').val() === '' ? null : $(self.sClass + ' .widget3Dsoft-atelier').val();

        if (iAnnee === "" || iMois === "") {
            var oDate = new Date;
            var iAnnee = oDate.getFullYear();
            var iMois = parseInt(oDate.getMonth()) + 1;
        }

        //On met en cache l'anne et le mois choisi

        self.sAnnee = iAnnee;
        self.sMois = iMois;
        var sMois = iMois < 10 ? '0' + iMois : iMois;sMois = iMois < 10 ? '0' + iMois : iMois;
        
        //If we havn't infos of this month, we search it
        if (self.jCalendrier[iIdAtelier] === undefined
                || jQuery.isEmptyObject(self.jCalendrier[iIdAtelier])
                || self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)] === undefined
                || jQuery.isEmptyObject(self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)])) {

            self.searchCalendar(iAnnee, iMois, self,function(){
                oCalendar = self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)];
                self.displayCalendar(self, self.sClass + ' .widget3Dsoft-calendarRestitution', iMois, iAnnee, 'showCalendarRestitution', 'selectDayRestitution', oCalendar, 'widget3Dsoft-calRestitution', self.rendezvous.sDateRestitution,callback);
            });

        }else{
            oCalendar = self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)];
            self.displayCalendar(self, self.sClass + ' .widget3Dsoft-calendarRestitution', iMois, iAnnee, 'showCalendarRestitution', 'selectDayRestitution', oCalendar, 'widget3Dsoft-calRestitution', self.rendezvous.sDateRestitution,callback);
        }
        
    }
};

/**
 * Quand on clique sur un jour du calendrier restitution
 * @param widget3Dsoft self
 * @param {type} iDay
 * @param {type} iMois
 * @param {type} iAnnee
 * @returns {undefined}
 */
Widget3dsoft.prototype.selectDayRestitution = function (self, iDay, iMois, iAnnee) {

    self.completeJourInfo(self, self.sClass + ' .widget3Dsoft-restitution', iDay, iMois, iAnnee);

    
    var iYearReception = parseInt(self.rendezvous.sDateReception.split("-")[0], 10); // annÃƒÂ©e
    var iMonthReception = parseInt(self.rendezvous.sDateReception.split("-")[1], 10); // mois
    var iDayReception = parseInt(self.rendezvous.sDateReception.split("-")[2], 10); // jour
    
    var bReceptionBeforeRestitution =   (iYearReception < iAnnee) 
                                 || (iYearReception == iAnnee && iMonthReception < iMois) 
                                 || (iYearReception == iAnnee && iMonthReception == iMois && iDayReception <= iDay);

    //Seulement si ce jour est selectionnable
    var sMois = iMois < 10 ? '0' + iMois : iMois;
    
    if(!bReceptionBeforeRestitution){
        //Reception is not before restitution
        alert(self.sLanguage.DATES_MSG_RESTITUTION_NOT_BEFORE_RECEPTION)
    }else if ($(self.sClass + ' .widget3Dsoft-calRestitution_' + String(iDay) + '_' + String(sMois) + '_' + String(iAnnee)).hasClass('pointer')) {
        self.sDay = iDay;

        //Design the day selected
        $(self.sClass + ' .widget3Dsoft-calendarRestitution .day').removeClass('daySelected');
        $(self.sClass + ' .widget3Dsoft-calRestitution_' + iDay + '_' + sMois + '_' + iAnnee).addClass('daySelected');

        //On met aÂ  jour la date de restitution de l'objet rendez vous
        self.rendezvous.sDateRestitution = iAnnee + '-' + sMois + '-' + iDay;
        //self.rendezvous.iHeureRestitution = null;
        $(self.sClass + ' .widget3Dsoft-dateRestSelected').html(self.formatDate(self.rendezvous.sDateRestitution));
        $(self.sClass + ' .widget3Dsoft-heureRestSelected').html('');

        //On va chercher les receptionnaires et leurs horaires, sauf si on a pas de liste dÃ©roulante receptionnaires
        if($(self.sClass + ' .widget3Dsoft-receptionnaire').val() !== undefined){
            self.retrieveReceptionnairesAndHours(self, iDay, iMois, iAnnee,function(){
                //Hours
                self.displayHours(self, self.sClass + ' .widget3Dsoft-restitution-plageHoraire', self.rendezvous.sDateRestitution, 'chooseHourRestitution');
                $(self.sClass + ' .widget3Dsoft-divrestitution-hours').show();// fin row
                $(self.sClass + ' .arrow_hour_restitution').attr('src', self.sServerURL + 'img/rec_arrow_up.png');
                $(self.sClass + ' .container_plage_horaire_restitution').show();
                //on va chercher les vehicules de courtoisie
                //self.showVehiculesCourtoisie(self);
            });
        }
        

    }
};

/**
 * 
 * @param string h
 * @param widget3Dsoft self
 */
Widget3dsoft.prototype.chooseHourRestitution = function (self, h) {
    self.rendezvous.iHeureRestitution = h;
    var aHour = self.convertMinToHour(h);

    //Afficher l'heure dans les en-tete
    $(self.sClass + ' .widget3Dsoft-heureRestSelected').html(aHour.sHeures + 'h' + aHour.sMins + ' <img src="' + self.sServerURL + 'img/edit-icon.png">');

    //Fermer les div
    $(self.sClass + ' .widget3Dsoft-pannelContentDateRest').toggle();

    //Afficher la selection du vehicule de courtoisie
    self.showVehiculesCourtoisie(self);
};

/**
 * 
 * @returns {undefined}
 */
Widget3dsoft.prototype.clickDisplayHourRestitution = function () {
    var self = this;
    if ($(self.sClass + ' .arrow_hour_restitution').attr('src') == self.sServerURL + 'img/rec_arrow_up.png') {
        $(self.sClass + ' .arrow_hour_restitution').attr('src', self.sServerURL + 'img/rec_arrow_down.png');
        $(self.sClass + ' .container_plage_horaire_restitution').hide();
    } else {
        $(self.sClass + ' .arrow_hour_restitution').attr('src', self.sServerURL + 'img/rec_arrow_up.png');
        $(self.sClass + ' .container_plage_horaire_restitution').show();
    }

};

//CALENDAR

/**
 * 
 * @param int iAnnee
 * @param int iMois
 * @param int search
 * @returns {undefined}
 */
Widget3dsoft.prototype.searchCalendar = function (iAnnee, iMois, search,callback) {
    var self = this;
    
    $(self.sClass + ' .widget3Dsoft-loading').show();
    var iNbJours = self.getNbDaysOfMonth(iAnnee, iMois);
    var sDateDebut = String(iAnnee) + '-' + String(iMois) + '-01';
    var sDateFin = String(iAnnee) + '-' + String(iMois) + '-' + String(iNbJours);
    var iIdAtelier = $(self.sClass + ' .widget3Dsoft-atelier').val();
    var iIdAtelierParam = (iIdAtelier == 0) ? "" : iIdAtelier;
    var sMois = iMois < 10 ? '0' + iMois : String(iMois);
    
    if(self.jCalendrier[iIdAtelier] === undefined || self.jCalendrier[iIdAtelier][String(iAnnee) + sMois] === undefined){
        self.ajax('POST',
                this.sServerURL + 'rest/calendar/search' + this.sParamsGet,
                {
                    sDateDebut: sDateDebut,
                    sDateFin: sDateFin,
                    iIdAtelier: iIdAtelierParam
                },
        function (response, statut) {
             if (bIEOld3Dsoft) {
                        response = JSON.parse(response);
                    }
            
            
            $(self.sClass + ' .widget3Dsoft-loading').hide();
            if (response.success === true) {
                if(self.jCalendrier[iIdAtelier] == undefined){
                    self.jCalendrier[iIdAtelier] = [];
                }

                var sMois = iMois < 10 ? '0' + iMois : iMois;
                if (!jQuery.isEmptyObject(response.calendar)) {
                    self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)] = response.calendar;
                } else {
                    self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)] = 'empty';
                }
                if (typeof (callback) == 'function') {
                        callback();
                }
                //self.showCalendar('','',self);//'','' seems today
            }
        },true
        );
    }
};

/**
 * 
 * @param widget3Dsoft self widget
 * @param {type} sSelecteur Endroit dans le dom oaÂ¹ sera place le calendrier
 * @param {type} iMois Mois aÂ  afficher
 * @param {type} iAnnee Annee aÂ  affiche
 * @param {type} sChangeMoisCallback quand on clique sur mois / annee suivant precedent
 * @param {type} sClickDay quand on clique sur un jour
 * @param {type} oCalendar Options par jour
 * @param {type} sIdCalendar Id du calendrier
 * @param {type} sDateSelected Date selectionnee
 * @returns {undefined}
 */
Widget3dsoft.prototype.displayCalendar = function (self, sSelecteur, iMois, iAnnee, sChangeMoisCallback, sClickDay, oCalendar, sIdCalendar, sDateSelected,callback) {
    
    //Mois en cours si pas de paramÃƒÆ’Ã‚Âªtre

    if (iAnnee == "" || iMois == "") {
        var oDate = new Date;
        iAnnee = oDate.getFullYear();
        iMois = parseInt(oDate.getMonth()) + 1;
    }

    iAnnee = parseInt(iAnnee);
    //Mois precedent

    var iAnneePrec = iAnnee - 1;
    var iMoisPrec = parseInt(iMois) - 1;
    var iAnPrec = iAnnee;
    if (iMoisPrec == 0)
    {
        iMoisPrec = 12;
        iAnPrec = iAnnee - 1
    }

    //Mois suivant

    var iAnneeSuit = iAnnee + 1;
    var iMoisSuit = parseInt(iMois) + 1;
    var suitan = parseInt(iAnnee);
    if (iMoisSuit == 13)
    {
        iMoisSuit = 1;
        suitan = iAnnee + 1;
    }

    //Aujourd'hui

    var datdujour = new Date;
    var datannee = datdujour.getFullYear();
    var datmonth = datdujour.getMonth() + 1;
    var datjour = datdujour.getDate();


    //CONSTRUCTION DU CALENDRIER

    //EN-TETE : barre changement de mois / annee

    var res = '<table class="' + sIdCalendar + ' tableCalendar">';
    res += '<tr>';
    res += '<th colspan="7" class="calendar-th-nav">';
    res += '<div class="calendar-nav">';

    //annee prec
    res += '    <span class="pointer pull-left "';
    res += '          onclick="' + self.sVarName + '.' + sChangeMoisCallback + '(' + self.sVarName + ',' + iMois + ',' + iAnneePrec + ');">';
    res += '         <img src="' + self.sServerURL + 'img/precedent.png">';
    res += '   </span>';

    //mois prec
    res += '    <span class="pointer pull-left padding-left-5"';
    res += '          onclick="' + self.sVarName + '.' + sChangeMoisCallback + '(' + self.sVarName + ',' + iMoisPrec + ',' + iAnPrec + ');">';
    res += '         <img src="' + self.sServerURL + 'img/back.png">';
    res += '    </span>';

    //Mois annee selectionne

    htmlSelect = '<select class="calendarSelectMois" onChange="' + self.sVarName + '.' + sChangeMoisCallback + '(' + self.sVarName + ',this.value,' + datannee + ');">';
    for (i = 1; i <= 12; i++) {
        var selectedMois = (i == iMois) ? 'selected' : '';
        htmlSelect += '<option ' + selectedMois + ' value="' + i + '">' + self.aMois[i] + '</option>';
    }
    htmlSelect += '</select>';

    res += htmlSelect + ' ' + iAnnee;

    //annee suiv
    res += '    <span class="pointer pull-right" ';
    res += '          onclick="' + self.sVarName + '.' + sChangeMoisCallback + '(' + self.sVarName + ',' + iMois + ',' + iAnneeSuit + ');">';
    res += '          <img src="' + self.sServerURL + 'img/suivant.png">';
    res += '    </span>';

    //mois suiv
    res += '    <span class="pointer pull-right padding-right-5" ';
    res += '          onclick="' + self.sVarName + '.' + sChangeMoisCallback + '(' + self.sVarName + ',' + iMoisSuit + ',' + suitan + ');">';
    res += ' <img src="' + self.sServerURL + 'img/next.png">';
    res += ' </span>';

    res += '</div>';
    res += '</th>';

    res += '</tr>';


    //JOURS DU CALENDRIER

    res += '<tr><th>' + self.sLanguage.DATES_JOUR_ABREGE_LUNDI + '</th>';
    res += '<th>' + self.sLanguage.DATES_JOUR_ABREGE_MARDI + '</th>'
    res += '<th>' + self.sLanguage.DATES_JOUR_ABREGE_MERCREDI + '</th>'
    res += '<th>' + self.sLanguage.DATES_JOUR_ABREGE_JEUDI + '</th>'
    res += '<th>' + self.sLanguage.DATES_JOUR_ABREGE_VENDREDI + '</th>'
    res += '<th>' + self.sLanguage.DATES_JOUR_ABREGE_SAMEDI + '</th>'
    res += '<th>' + self.sLanguage.DATES_JOUR_ABREGE_DIMANCHE + '</th></tr>';

    //Calcul Nb de jour du mois
    var datcalc = new Date(iAnnee, iMois - 1, 1, 1, 2, 1, 1);
    var datmax = new Date(iAnnee, iMoisSuit - 1, 1, 1, 2, 1, 1);
    datmax.setTime(datmax.getTime() - 24 * 60 * 60 * 1000);
    var nbjomois = datmax.getDate();

    //Boucle de remplissage des cases de debut a vide
    var nojo = datcalc.getDay() - 1;
    if (nojo == -1)
        nojo = 6;
    res += '<tr>';
    for (i = 0; i < nojo; i++)
    {
        res += '<td class="jour_vide"></td>';
    }

    sMois = (iMois < 10) ? '0' + iMois : String(iMois);

    //Boucle de remplissage des jours du mois
    for (i = 1; i <= nbjomois; i++) {
        if (nojo == 0) {
            //Lundi nouvelle ligne
            res += '<tr>';
        }
        var tempclss = '';
        if (nojo > 4) {
            //Week end
            tempclss = 'weekend';
        }

        if (iAnnee == datannee && iMois == datmonth && i == datjour) {
            //Aujourd'hui
            tempclss = 'today';
        }

        var sDay = (i < 10) ? '0' + i : String(i);

        //REMPLISSAGE DU JOUR
        var sJour = String(iAnnee) + '-' + String(sMois) + '-' + String(sDay);
        var iDay = parseInt(sDay);
        //True if the day is before today
        bDateBeforeToday =     (iAnnee < datannee) 
                            || (iAnnee == datannee && iMois < datmonth) 
                            || (iAnnee == datannee && iMois == datmonth && iDay < datjour);
        
        
        //In restitution calendar we can't choose a date before of the reception date
        var bReceptionBeforeRestitution = true;
        if(sSelecteur == self.sClass + ' .widget3Dsoft-calendarRestitution'){
            iYearReception = parseInt(self.rendezvous.sDateReception.split("-")[0], 10); // annÃƒÂ©e
            iMonthReception = parseInt(self.rendezvous.sDateReception.split("-")[1], 10); // mois
            iDayReception = parseInt(self.rendezvous.sDateReception.split("-")[2], 10); // jour
            
            bReceptionBeforeRestitution =   (iYearReception < iAnnee) 
                                 || (iYearReception == iAnnee && iMonthReception < iMois) 
                                 || (iYearReception == iAnnee && iMonthReception == iMois && iDayReception <= iDay)
        }
        
        if (oCalendar.hasOwnProperty(sJour) && !bDateBeforeToday && bReceptionBeforeRestitution) {

            //Ce jour a des options
            var oJour = oCalendar[sJour];

            var classTd = '';
            if (sDateSelected == sJour) {
                //Ce jour a ete selectionne
                classTd += ' daySelected';
            }

            var bJourSelectionnable = true;

            if (oJour.cal_heures_reservees < ((oJour.cal_heures_realisables - oJour.cal_heures_de_reserve) * 0.8)) {
                classTd += ' jour_libre pointer';
            } else if (oJour.cal_heures_reservees < oJour.cal_heures_realisables - oJour.cal_heures_de_reserve) {
                classTd += ' jour_possible pointer';
            } else if (oJour.cal_heures_reservees < oJour.cal_heures_realisables) {
                bJourSelectionnable = false;
                classTd += ' jour_plein cursor-not-allowed';
            } else {
                bJourSelectionnable = false;
                classTd += ' jour_capacite_depassee cursor-not-allowed';
            }

            res += '<td ';
            res += ' class="' + sIdCalendar + '_' + sDay + '_' + sMois + '_' + iAnnee + ' day ' + classTd + ' ' + tempclss + '"';
            res += ' onclick="' + self.sVarName + '.' + sClickDay + '(' + self.sVarName + ',\'' + sDay + '\',\'' + iMois + '\',\'' + iAnnee + '\');"';
            res += '>';
            res += sDay;
            res += '</td>';

        } else {
            //Rien de special pour ce jour
            res += '<td class="day jour_vide ' + tempclss + '">' + sDay + '</td>';
        }

        //Fin de la semaine
        nojo++
        if (nojo > 6)
        {
            res += '</tr>';
            nojo = 0;
        }
    }

    //Case vides de fin de mois (si on termine le mois avant la fin de la semaine
    if (nojo != 0)
    {
        nojo = 7 - nojo;
        for (i = 0; i < nojo; i++)
        {
            res += '<td class="jour_vide"></td>';
        }
    }


    //FIN DU CALENDRIER

    res += '</table>';

    $(sSelecteur).html(res);
    
    if(typeof(callback) == 'function'){
        callback();
    }
};

//RECEPTIONNAIRES

/**
 * bIe
 * 
 * @param int iDay
 * @param int iMois
 * @param int iAnnee
 */
Widget3dsoft.prototype.retrieveReceptionnairesAndHours = function (self, iDay, iMois, iAnnee,callback) {
    self = this;

    $(self.sClass + ' .widget3Dsoft-loading').show();
    

    var sDay = (iDay < 10) ? '0' + parseInt(iDay) : iDay;
    var sMois = (iMois < 10) ? '0' + parseInt(iMois) : iMois;
    
    self.ajax('POST',
            this.sServerURL + 'rest/calendar/receptionnaires' + this.sParamsGet,
            {
                sDate: iAnnee + '-' + sMois + '-' + sDay
            },
            function (response, statut) {
                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }

                if (response.success === true) {
                    
                    $.each(response.aReceptionsHours, function (key, value) {
                        self.jReceptionsHours[key] = value;
                    });
                    $.each(response.aReceptionnaires, function (cle, valeur) {
                        self.jReception[cle] = valeur;
                    });
                
                    self.aReception = [];
                    $.each(self.jReception, function (key, oReceptionnaire) {
                        self.aReception[key] = oReceptionnaire._REC_DESIGNATION;
                    });
                }
                if (typeof (callback) == 'function') {
                                callback();
                }
                $(self.sClass + ' .widget3Dsoft-loading').hide();
            },true
    );

};

/**
 * 
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.changeReceptionnaire = function (self) {
    console.log('changeReceptionnaire(self) ->');
    self.rendezvous.iIdReceptionnaire = $(self.sClass + ' .widget3Dsoft-receptionnaire').val();
    self.displayHours(self, self.sClass + ' .widget3Dsoft-reception-plageHoraire', self.rendezvous.sDateReception, 'chooseHourReception');
}

//JOUR INFO

/**
 * Charge
 * @param widget3Dsoft self
 * @param {type} iDay
 * @param {type} iMois
 * @param {type} iAnnee
 * @returns {undefined}
 */
Widget3dsoft.prototype.completeJourInfo = function (self, sSelecteur, iDay, iMois, iAnnee) {
    var iIdAtelier = $(self.sClass + ' .widget3Dsoft-atelier').val();
    iMois = parseInt(iMois);
    var sMois = iMois < 10 ? '0' + iMois : iMois;
    iDay = parseInt(iDay);
    var sDay = iDay < 10 ? '0' + iDay : iDay;

    var oJour = self.jCalendrier[iIdAtelier][String(iAnnee) + String(sMois)][String(iAnnee) + '-' + String(sMois) + '-' + String(sDay)];

    //Charge
    var classCharge = '';
    if (oJour.cal_heures_reservees < ((oJour.cal_heures_realisables - oJour.cal_heures_de_reserve) * 0.8)) {
        classCharge = 'jour_libre';
    } else if (oJour.cal_heures_reservees < oJour.cal_heures_realisables - oJour.cal_heures_de_reserve) {
        classCharge = 'jour_possible';
    } else if (oJour.cal_heures_reservees < oJour.cal_heures_realisables) {
        classCharge = 'jour_plein';
    } else {
        classCharge = 'jour_capacite_depassee';
    }


    //progress bar  
    var chargePercent = parseFloat(oJour.charge * 100).toFixed(2);
    var widhtProgress = (chargePercent > 100) ? 100 : chargePercent;
    var sHtml = '<div class="padding-none margin-none progress">';
        sHtml += '  <div class="progress-bar ' + classCharge + '"  role="progressbar"  aria-valuenow="' + widhtProgress + '" style="width:' + widhtProgress + '%;">';
        sHtml += '' + chargePercent + '%' + '';
        sHtml += '  </div>';
        sHtml += '</div>';

    $(sSelecteur + '-jourCharge').html(sHtml);

    //Heures restantes
    var sHeureRestantes = parseInt((oJour.cal_heures_realisables - oJour.cal_heures_reservees) / 60);
    var sMinReservees = parseInt(oJour.cal_heures_reservees % 60);
    var sHeureRealisables = parseInt(oJour.cal_heures_realisables / 60);
    var sMinRealisables = parseInt(oJour.cal_heures_realisables % 60);
    
    //Add a '0' if it's < 10 (01 02 03 ...)
    if (sHeureRestantes < 10) {
        sHeureRestantes = '0' + sHeureRestantes;
    }
    if (sMinReservees < 10) {
        sMinReservees = '0' + sMinReservees;
    }
    if (sHeureRealisables < 10) {
        sHeureRealisables = '0' + sHeureRealisables;
    }
    if (sMinRealisables < 10) {
        sMinRealisables = '0' + sMinRealisables;
    }

    sHtml = sHeureRestantes + ':' + sMinReservees + ' / ' + sHeureRealisables + ':' + sMinRealisables;
    $(sSelecteur + '-heuresRestantes').html(sHtml);

    //Vehicules dispos

    $(sSelecteur + '-vehDispoM').html(oJour.veh_remplacement - oJour.veh_reserve_m + ' / ' + oJour.veh_remplacement);
    $(sSelecteur + '-vehDispoAM').html(oJour.veh_remplacement - oJour.veh_reserve_a + ' / ' + oJour.veh_remplacement);
}


//VEHICULE COURTOISIE

/**
 * 
 * @param int iDay
 * @param int iMois
 * @param int iAnnee
 */
Widget3dsoft.prototype.showVehiculesCourtoisie = function (self) {
    self = this;
    
    if(self.oSite.bShowShuttle){
        $(self.sClass + ' .widget3Dsoft-divbShuttle').show();
    }

    if(self.oSite.bGestionVehRemp){
        //If veh remp is active      
        $(self.sClass + ' .widget3Dsoft-divVehCourtoisie').show();
        $(self.sClass + ' .widget3Dsoft-divclientAttend').show();
        $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').click(function(){
            self.checkVehCourtoisie(self);
        });
        
    }else{

        $(self.sClass + ' .widget3Dsoft-loading').show();
        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').empty();
        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').append($('<option>', {
            value: '',
            text: self.sLanguage.DATES_VEHICULE_COURTOISIE_AUCUN,
            style : "background-color=#fff;color:#000"
        }));
        $(self.sClass + ' .widget3Dsoft-divVehCourtoisie').show();
        $(self.sClass + ' .widget3Dsoft-divclientAttend').show();

        self.ajax('POST',
                this.sServerURL + 'rest/vehicule/courtoisie' + this.sParamsGet,
                {
                    sDateReception: self.rendezvous.sDateReception,
                    sDateRestitution: self.rendezvous.sDateRestitution,
                    sHeureReception: self.rendezvous.iHeureReception,
                    sHeureRestitution: self.rendezvous.iHeureRestitution,
                    iIdPret: (self.rendezvous.vehCourtoisie != null) ? self.rendezvous.vehCourtoisie.pret_id : null
                },
        function (response, statut) {
            
            $(self.sClass + ' .widget3Dsoft-loading').hide();
            if (bIEOld3Dsoft) {
                        response = JSON.parse(response);
            }

            if (response.success === true) {
                self.aVehCourtoisie = response.datas.aVehicules;              
                var nVehCourtoisieSelectDispo = false;

                for (iIdVehCourtoisie in self.aVehCourtoisie) {

                    if (self.rendezvous && self.rendezvous.vehCourtoisie) {
                        if (self.rendezvous.vehCourtoisie.id == iIdVehCourtoisie ) {
                            nVehCourtoisieSelectDispo = true;
                        }
                    }

                    var sLibelle = self.aVehCourtoisie[iIdVehCourtoisie].cap_libelle + ' ';
                    sLibelle += self.aVehCourtoisie[iIdVehCourtoisie].libelle_modele + ' ';
                    sLibelle += self.aVehCourtoisie[iIdVehCourtoisie].immatriculation + ' | ';
                    sLibelle += self.aVehCourtoisie[iIdVehCourtoisie].kilometrage + ' ' + self.sLanguage.DATES_VEHICULE_COURTOISIE_DIST_UNIT;

                    $(self.sClass + ' .widget3Dsoft-vehCourtoisie')
                            .append('<option class="vehCourt' + self.aVehCourtoisie[iIdVehCourtoisie].id + '" style="background-color:#' + self.aVehCourtoisie[iIdVehCourtoisie].cap_backcolor + ';color:#' + self.aVehCourtoisie[iIdVehCourtoisie].cap_fontcolor + ';" value="' + self.aVehCourtoisie[iIdVehCourtoisie].id + '">' + sLibelle + '</option>');
                }

                if (self.rendezvous) {

                    if ( self.rendezvous.vehCourtoisie && nVehCourtoisieSelectDispo ) {
                        if(self.rendezvous.bVehCourtoisie == true){
                            $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',true); 
                        }

                        var sLibelle = self.rendezvous.vehCourtoisie.cap_libelle + ' ';
                        sLibelle += self.rendezvous.vehCourtoisie.libelle_modele + ' ';
                        sLibelle += self.rendezvous.vehCourtoisie.immatriculation + ' | ';
                        sLibelle += self.rendezvous.vehCourtoisie.kilometrage + ' ' + self.sLanguage.DATES_VEHICULE_COURTOISIE_DIST_UNIT;

                        $(self.sClass + ' .widget3Dsoft-vehCourtoisie')
                                .append('<option class="vehCourt' + self.rendezvous.vehCourtoisie.id + '" style="background-color:#' + self.rendezvous.vehCourtoisie.cap_backcolor + ';color:#' + self.rendezvous.vehCourtoisie.cap_fontcolor + ';" value="' + self.rendezvous.vehCourtoisie.id + '" selected >' + sLibelle + '</option>');
                    } else {
                        self.rendezvous.bVehCourtoisie = false;
                        $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked', false); 
                        
                        self.rendezvous.vehCourtoisie = null;
                    }
                }

                if (self.rendezvous.iIdVehCourtoisie !== undefined) {
                    $(self.sClass + ' .widget3Dsoft-vehCourtoisie').val(self.rendezvous.iIdVehCourtoisie);
                
                    $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').click(function(){
                        self.checkVehCourtoisie(self);
                    });
                }
            }
        },true
        );
    }
};

/**
 * 
 */
Widget3dsoft.prototype.searchVehiculesCourtoisie = function (self, iIdVehCourtoisie, callback) {
    self = this;

    $(self.sClass + ' .widget3Dsoft-loading').show();
    if (iIdVehCourtoisie != undefined && iIdVehCourtoisie != null) {

        self.ajax('POST',
                this.sServerURL + 'rest/vehicule/courtoisie/search' + this.sParamsGet,
                {
                    iIdVehCourtoisie: iIdVehCourtoisie,
                    iIdRendezvous: this.rendezvous.iIdRendezvous
                },
        function (response, statut) {
            $(self.sClass + ' .widget3Dsoft-loading').hide();

            if (response.success === true) {
                self.rendezvous.vehCourtoisie = response.datas.oVehCourtoisie;
            }
            
            if (typeof (callback) == 'function') {
                callback();
            }
        },true
        );

        return self.rendezvous.vehCourtoisie;
    }else if (typeof (callback) == 'function') {
                callback();
    }
};

/**
 * 
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.selectVehCourtoisie = function (self) {
    var iIdVehCourtoisie = $(self.sClass + ' .widget3Dsoft-vehCourtoisie').val();
    if (iIdVehCourtoisie == '') {
        self.rendezvous.vehCourtoisie = null;
        self.rendezvous.iIdVehCourtoisie = null;
        self.rendezvous.bVehCourtoisie = false;
        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').css('color',"#000");
        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').css('background-color',"#fff");
        $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',false); 
    } else {
        $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',true); 
        $(self.sClass + ' .widget3Dsoft-clientAttend').prop('checked',false); 
        self.rendezvous.vehCourtoisie = self.aVehCourtoisie[iIdVehCourtoisie];
        self.rendezvous.iIdVehCourtoisie = iIdVehCourtoisie;
        self.rendezvous.bVehCourtoisie = true;
        sColor = $(self.sClass + ' .vehCourt' + iIdVehCourtoisie).css('color');
        sBackground = $(self.sClass + ' .vehCourt' + iIdVehCourtoisie).css('background-color');
        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').css('color',sColor);
        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').css('background',sBackground);
    }

};

//Valider

/**
 * 
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.btnValiderDates = function (self) {    
   
    if (self.rendezvous.sDateReception === null){
        self.alertMessage(self, self.sLanguage.DATES_MSG_ERROR_DATE_RECEPTION); 
        
    }else if(self.rendezvous.iHeureReception === null){
        self.alertMessage(self, self.sLanguage.DATES_MSG_ERROR_HEURE_RECEPTION); 
        
    }else if(self.rendezvous.sDateRestitution === null){
        self.alertMessage(self, self.sLanguage.DATES_MSG_ERROR_DATE_RESTITUTION); 
        
    }else if(  (self.oSite.bGestionVehRemp != true || self.oSite.bGestionVehRemp != 1)  
            &&  self.rendezvous.bVehCourtoisie 
            && (    self.rendezvous.iIdVehCourtoisie == null 
                || self.rendezvous.iIdVehCourtoisie == undefined
                || self.rendezvous.iIdVehCourtoisie == '')){
        self.alertMessage(self, self.sLanguage.DATES_MSG_ERROR_VEH_COURTOISIE); 
        
    } else {
       
        $(self.sClass + ' .widget3Dsoft-message').hide();
        if (self.rendezvous.iIdReceptionnaire === null || self.rendezvous.iIdReceptionnaire === '') {
           
            //Si le receptionnaire n'a pas ete selectionne on en choisi un aleatoirement libre a  ce creneau
            var aKeysInterventions = Object.keys(self.jReceptionsHours[self.rendezvous.sDateReception]);

            do {
                iKeyAlea = Math.floor(Math.random() * aKeysInterventions.length);

                if (aKeysInterventions[iKeyAlea] != 0 && aKeysInterventions[iKeyAlea] != '0' ){
                    self.rendezvous.iIdReceptionnaire = aKeysInterventions[iKeyAlea];
                }
                
                aKeysInterventions.splice(iKeyAlea, 1);
           
            } while ( (aKeysInterventions.length > 0 && self.getDisponnibiliteHoraire(self, self.rendezvous.sDateReception,
                    self.rendezvous.iHeureReception, self.rendezvous.iIdReceptionnaire) !== 'heure_disponnible') 
                || self.rendezvous.iIdReceptionnaire == null || self.rendezvous.iIdReceptionnaire == '');
 
        } else {
            // console.log('in else');
        }
        

        self.rendezvous.bLeClientAttend = $(self.sClass + ' .widget3Dsoft-clientAttend').is(':checked');
        
        //On passe a l'etape finale
        self.showFormValidation(self);
    }

};


Widget3dsoft.prototype.checkClientAttendLibelle = function (self) {
    //toggle the checkbox
    $(self.sClass + ' .widget3Dsoft-clientAttend').prop('checked',!$(self.sClass + ' .widget3Dsoft-clientAttend').is(':checked'));
    self.checkClientAttend(self);
    
};

Widget3dsoft.prototype.checkClientAttend = function (self) {
    if(self.oSite.bGestionVehRemp){
        //This site use an extern service for veh courtoisie
        if($(self.sClass + ' .widget3Dsoft-clientAttend').is(':checked')){
          //clientAttend is checked
          $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',false); 
          self.rendezvous.bVehCourtoisie= false;
        }
    }else{
        if($(self.sClass + ' .widget3Dsoft-clientAttend').is(':checked')){
            self.turnOffTransport(self);
            $(self.sClass + ' .widget3Dsoft-clientAttend').prop('checked',true);
            self.rendezvous.bLeClientAttend = true;
        }else{
            var iIdVehCourtoisie = $(self.sClass + ' .widget3Dsoft-vehCourtoisie').val();
            $(self.sClass + ' .widget3Dsoft-divVehCourtoisie').show();
            self.rendezvous.vehCourtoisie = self.aVehCourtoisie[iIdVehCourtoisie];
            self.rendezvous.iIdVehCourtoisie = iIdVehCourtoisie;
            self.rendezvous.bLeClientAttend = false;
        }
    }
};

Widget3dsoft.prototype.checkVehCourtoisieLibelle = function (self) {
    //toggle the checkbox
    $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',!$(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').is(':checked'));
    self.checkVehCourtoisie(self);
    
}

Widget3dsoft.prototype.checkVehCourtoisie = function (self) {
    if($(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').is(':checked')){
        self.turnOffTransport(self);
        $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',true);
        self.rendezvous.bVehCourtoisie = true;
    }else{
        self.rendezvous.bVehCourtoisie= false;
    }
};

Widget3dsoft.prototype.checkBShuttleLibelle = function (self) {
    //toggle the checkbox
    
    $(self.sClass + ' .widget3Dsoft-bShuttleCheckbox').prop('checked',!$(self.sClass + ' .widget3Dsoft-bShuttleCheckbox').is(':checked'));
    self.checkBShuttle(self);
    
}
Widget3dsoft.prototype.checkBShuttle = function (self) {
    
    if($(self.sClass + ' .widget3Dsoft-bShuttleCheckbox').is(':checked')){
         //Other false
        self.turnOffTransport(self);
        
        //And check this
        self.rendezvous.bShuttle = true;
        $(self.sClass + ' .widget3Dsoft-bShuttleCheckbox').prop('checked',true);
    }else{
               
        self.rendezvous.bShuttle = false;
        $(self.sClass + ' .widget3Dsoft-bShuttle').prop('checked',false);
    }
};

Widget3dsoft.prototype.turnOffTransport = function (self) {
    
    self.rendezvous.bLeClientAttend = false;
    $(self.sClass + ' .widget3Dsoft-clientAttend').prop('checked',false);
    
    self.rendezvous.bVehCourtoisie= false;
    self.rendezvous.iIdVehCourtoisie = null;
    self.rendezvous.vehCourtoisie = null;
    $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',false);
    $(self.sClass + ' .widget3Dsoft-vehCourtoisie').val('');
    $(self.sClass + ' .widget3Dsoft-vehCourtoisie').css('color',"#000");
    $(self.sClass + ' .widget3Dsoft-vehCourtoisie').css('background-color',"#fff");
    $(self.sClass + ' .widget3Dsoft-vehCourtoisieCheckbox').prop('checked',false); 

    self.rendezvous.bShuttle = false;
    $(self.sClass + ' .widget3Dsoft-bShuttleCheckbox').prop('checked',false);
};